import { render, staticRenderFns } from "./ResendVerificationEmail.vue?vue&type=template&id=2f037cfe&"
import script from "./ResendVerificationEmail.vue?vue&type=script&lang=js&"
export * from "./ResendVerificationEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports